import { OnInit, Directive, inject, input } from '@angular/core'
import { IconButtonComponent, IconButtonThemeType, IconButtonThemeSize, IconButtonIconSize } from './icon-button.component'


@Directive({
  selector: '[icon-btn-unstyled]',
  standalone: false,
})
export class IconButtonUnstyledDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  ngOnInit(): void {
    this._iconButton.themeType.set(IconButtonThemeType.Unstyled)
  }
}

@Directive({
  selector: '[icon-btn-icon-only]',
  standalone: false,
})
export class IconButtonIconOnlyDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  ngOnInit(): void {
    this._iconButton.themeType.set(IconButtonThemeType.IconOnly)
  }
}

@Directive({
  selector: '[icon-btn-outlined]',
  standalone: false,
})
export class IconButtonOutlinedDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  ngOnInit(): void {
    this._iconButton.themeType.set(IconButtonThemeType.Outlined)
  }
}

@Directive({
  selector: '[icon-btn-small]',
  standalone: false,
})
export class IconButtonSmallDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  ngOnInit(): void {
    this._iconButton.themeSize.set(IconButtonThemeSize.Small)
  }
}

@Directive({
  selector: '[icon-btn-medium]',
  standalone: false,
})
export class IconButtonMediumDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  ngOnInit(): void {
    this._iconButton.themeSize.set(IconButtonThemeSize.Medium)
  }
}

@Directive({
  selector: '[icon-btn-responsive]',
  standalone: false,
})
export class IconButtonResponsiveDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  iconBtnResponsive = input('medium', {
    alias: 'icon-btn-responsive',
  })

  ngOnInit(): void {
    switch (this.iconBtnResponsive()) {
      case 'medium':
        this._iconButton.themeSize.set(IconButtonThemeSize.ResponsiveMedium)
        break
    }
  }
}

@Directive({
  selector: '[icon-btn-icon-xsmall]',
  standalone: false,
})
export class IconButtonIconXSmallDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  ngOnInit(): void {
    this._iconButton.iconSize.set(IconButtonIconSize.XSmall)
  }
}

@Directive({
  selector: '[icon-btn-icon-small]',
  standalone: false,
})
export class IconButtonIconSmallDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  ngOnInit(): void {
    this._iconButton.iconSize.set(IconButtonIconSize.Small)
  }
}

@Directive({
  selector: '[icon-btn-icon-medium]',
  standalone: false,
})
export class IconButtonIconMediumDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  ngOnInit(): void {
    this._iconButton.iconSize.set(IconButtonIconSize.Medium)
  }
}

@Directive({
  selector: '[icon-btn-icon-large]',
  standalone: false,
})
export class IconButtonIconLargeDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  ngOnInit(): void {
    this._iconButton.iconSize.set(IconButtonIconSize.Large)
  }
}

@Directive({
  selector: '[icon-btn-icon-responsive]',
  standalone: false,
})
export class IconButtonIconResponsiveDirective implements OnInit {
  private _iconButton = inject(IconButtonComponent)
  iconBtnIconResponsive = input<'small'|'medium'|'large'>('medium', {
    alias: 'icon-btn-icon-responsive',
  })

  ngOnInit(): void {
    switch (this.iconBtnIconResponsive()) {
      case 'small':
        this._iconButton.iconSize.set(IconButtonIconSize.ResponsiveSmall)
        break
      case 'medium':
        this._iconButton.iconSize.set(IconButtonIconSize.ResponsiveMedium)
        break
      case 'large':
        this._iconButton.iconSize.set(IconButtonIconSize.ResponsiveLarge)
        break
    }
  }
}
